/*
 * Ask Andi — AI shopping assistant (front-end).
 *
 * This build ships a MOCK responder so the UI runs in the theme preview with no
 * backend. To go live, flip USE_BACKEND to true and implement the App Proxy at
 * /apps/andi/chat. Contract (both mock and real return the same shape):
 *
 *   REQUEST   POST /apps/andi/chat   { message: string, history: [{role,text}] }
 *   RESPONSE  { reply: string,
 *               products: [{ title, handle, price, compare_at?, image? }],
 *               chips: string[] }
 *
 * On the server, `reply`/`products` come from GLM (Zhipu, e.g. glm-4.6) via its
 * OpenAI-compatible chat/completions endpoint using function calling
 * (search_products, check_stock, get_shipping) against the Storefront/Admin API;
 * `products[].handle` links to /products/{handle}.
 */
(function () {
  var USE_BACKEND = true;
  /* Same-origin App Proxy path. Going through the proxy lets the backend identify
     signed-in shoppers from Shopify's signed logged_in_customer_id. */
  var CONFIG = window.AD_ANDI || {};
  var ENDPOINT = CONFIG.endpoint || '/apps/andi/chat';

  function channelOf() {
    var w = window.innerWidth;
    return w >= 1024 ? 'desktop' : (w >= 768 ? 'tablet' : 'mobile');
  }
  function sessionId() {
    try {
      var k = 'andi_sid';
      var ttl = 4 * 60 * 60 * 1000;
      var now = Date.now();
      var raw = localStorage.getItem(k);
      var saved = null;
      try { saved = raw ? JSON.parse(raw) : null; } catch (e) { saved = null; }
      if (saved && saved.id && now - Number(saved.updatedAt || 0) < ttl) {
        saved.updatedAt = now;
        localStorage.setItem(k, JSON.stringify(saved));
        return saved.id;
      }
      var v = 's-' + now.toString(36) + Math.random().toString(36).slice(2, 8);
      localStorage.setItem(k, JSON.stringify({ id: v, updatedAt: now }));
      return v;
    } catch (e) { return 'anon'; }
  }
  /* Proof that this browser is the one that started the conversation.
     Knowing the sessionId used to be enough to read a whole transcript back, and
     the sessionId is not a secret: it rode in the query string of a poll that
     fires every 8 seconds, so it reached proxy logs, the Referer every
     third-party script on the page can see, and browser history. The backend now
     hands back a readToken with each reply; it is kept here and sent as a header,
     never in a URL, which is the whole point.
     Stored against the session it belongs to so a rotated session (4h TTL above)
     cannot send a stale one. */
  function rememberToken(data) {
    try {
      if (data && data.readToken) {
        localStorage.setItem('andi_rt', JSON.stringify({ sid: sessionId(), t: String(data.readToken) }));
      }
    } catch (e) { /* private mode: the poll still works, it just falls back */ }
    return data;
  }
  function readToken() {
    try {
      var saved = JSON.parse(localStorage.getItem('andi_rt') || 'null');
      return saved && saved.sid === sessionId() ? String(saved.t || '') : '';
    } catch (e) { return ''; }
  }
  /* The sessionId goes in a header too, for the same reason: it is the key to the
     whole transcript and does not belong in a logged URL. The backend reads the
     header first and still accepts the old query form, so a cached copy of this
     file keeps working. */
  function readHeaders() {
    var h = { 'X-Andi-Session-Id': sessionId() };
    var t = readToken();
    if (t) h['X-Andi-Read-Token'] = t;
    return h;
  }

  /* Handle + id let the backend load the real product description and specs, so Andi
     answers "will it fit?" from the catalogue instead of deflecting to a human. */
  function productHandle() {
    var m = location.pathname.match(/\/products\/([a-zA-Z0-9-]+)/);
    return m ? m[1] : '';
  }
  function productId() {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (meta && meta.product && meta.product.id) return String(meta.product.id);
    } catch (e) { /* meta is theme-dependent; the handle alone is enough */ }
    var el = document.querySelector('[data-product-id]');
    return el ? String(el.getAttribute('data-product-id') || '') : '';
  }
  var BEHAVIOR_KEY = 'andi_behavior';
  var BEHAVIOR_MAX = 30;

  function readBehavior() {
    try { var raw = JSON.parse(sessionStorage.getItem(BEHAVIOR_KEY) || '[]'); return Array.isArray(raw) ? raw : []; }
    catch (e) { return []; }
  }
  function writeBehavior(list) {
    try { sessionStorage.setItem(BEHAVIOR_KEY, JSON.stringify(list.slice(-BEHAVIOR_MAX))); } catch (e) { /* private mode */ }
  }
  function recordBehavior(type, detail) {
    var list = readBehavior();
    var last = list[list.length - 1];
    if (last && last.type === type && last.detail === detail) {
      last.count = (last.count || 1) + 1;
      last.at = Date.now();
    } else {
      list.push({ type: type, detail: String(detail || '').slice(0, 180), path: location.pathname, at: Date.now() });
    }
    writeBehavior(list);
  }
  function productTitleOnPage() {
    var el = document.querySelector('h1, .product__title, [data-product-title]');
    return el ? el.textContent.trim().slice(0, 180) : document.title;
  }
  function trackBehavior() {
    recordBehavior('page_view', document.title);
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      if (form.action.indexOf('/cart/add') > -1) recordBehavior('add_to_cart', productTitleOnPage());
      else if (form.action.indexOf('/checkout') > -1) recordBehavior('checkout_started', document.title);
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest('[name="add"], [data-add-to-cart], .product-form__submit')) {
        recordBehavior('add_to_cart', productTitleOnPage());
      } else if (e.target.closest('[name="checkout"], a[href*="/checkout"]')) {
        recordBehavior('checkout_started', document.title);
      }
    }, true);
  }
  function pageContext() {
    var title = document.querySelector('h1, .product__title, [data-product-title]');
    return {
      url: location.href,
      path: location.pathname,
      pageTitle: document.title,
      productTitle: title ? title.textContent.trim().slice(0, 180) : '',
      productHandle: productHandle(),
      productId: productId()
    };
  }

  var GREETING = {
    reply: "Welcome to AlwaysDirect support. I can help you find suitable products, compare options, or check delivery and pickup guidance.",
    products: [],
    chips: ['Track my order', 'Compare similar options', 'Delivery & pickup help']
  };

  /* Image URLs are the products' own featured_image, taken from
     /products/<handle>.js — keep them in sync with the handle above, and always
     verify a new one loads: a card with no usable image falls back to a generic
     box glyph, which looks broken next to a card that has a photo. */
  var POPULAR_PRODUCTS = [
    { title: '72 inch Basketball System', handle: '72-inch-professional-in-ground-basketball-system-with-hoop-tempered-glass-backboard', price: '$1,288', image: '//cdn.shopify.com/s/files/1/0725/1086/5724/products/03_2.jpg?v=1714732617&width=240', tags: /basketball|hoop|sport|kids|outdoor/i },
    { title: '72 inch Electric Fireplace', handle: '72-slim-trim-black-built-in-recessed-wall-mounted-heater-electric-fireplace', price: '$918', image: '//cdn.shopify.com/s/files/1/0725/1086/5724/files/bef-72bif04_main.png?v=1743658990&width=240', tags: /fireplace|heater|heating|winter|warm/i },
    { title: '3 Person Steam Sauna', handle: '3-person-indoor-corner-traditional-steam-sauna-ef3c', price: '$2,999', image: '//cdn.shopify.com/s/files/1/0725/1086/5724/files/AD-QD-EF3C.png?v=1782154299&width=240', tags: /sauna|steam|health|wellness/i },
    { title: '5x10m Heavy Duty Marquee', handle: 'commercial-grade-heavy-duty-galvanised-frame-5x10m-party-tent-wedding-marquee', price: '$849', image: '//cdn.shopify.com/s/files/1/0725/1086/5724/products/AD-P510101.jpg?v=1714733037&width=240', tags: /marquee|gazebo|tent|party|market|outdoor/i },
    { title: '900x900 Shower Cubicle', handle: 'shower-screen-cubicle-enclosure-w-t-base-bathroom-900x900x2300mm-white-8226a-copy', price: '$619', image: '//cdn.shopify.com/s/files/1/0725/1086/5724/files/1806a.jpg?v=1763094449&width=240', tags: /shower|bathroom|cubicle|screen|reno/i },
    { title: '2400W Outdoor Heater', handle: '2400w-infrared-electric-radiant-heater', price: '$199', image: '//cdn.shopify.com/s/files/1/0725/1086/5724/products/2400_1.jpg?v=1677119975&width=240', tags: /heater|heating|patio|outdoor|winter/i }
  ];

  /* Shopify serves whatever `width` the URL asks for, and the stored URLs ask for
     240px — fine for a 46px thumb, visibly soft once the card paints a 140-150px
     image on a 2x screen. Rewrite the parameter to 2x the painted box instead of
     shipping bigger images everywhere. Non-Shopify URLs are returned untouched. */
  function sizedImage(url, box) {
    if (!url || url.indexOf('cdn.shopify.com') === -1) return url || '';
    var want = 'width=' + Math.round(box * 2);
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1' + want);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + want;
  }

  /* Placeholder shown when a card has no image, or when the image 404s.
     dropDeadImages() removes the broken <img> so the CSS sibling rule
     (img + .andi-ph { display:none }) stops hiding this. */
  var PLACEHOLDER_SVG = '<svg class="andi-ph" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 7 12 3 4 7v10l8 4 8-4V7Z"/><path d="m4 7 8 4 8-4M12 11v10"/></svg>';

  function dropDeadImages(scope) {
    var imgs = scope.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].addEventListener('error', function () { this.remove(); });
    }
  }

  function relatedProducts(text) {
    var matches = POPULAR_PRODUCTS.filter(function (p) { return p.tags && p.tags.test(text || ''); });
    return (matches.length ? matches : POPULAR_PRODUCTS).slice(0, 2);
  }

  /* ---- MOCK knowledge base (replace with real Claude backend) ---- */
  var MOCK = [
    { match: /fireplace|heater|heating|fire/i, reply: "Great pick for winter. This 2000W unit has a realistic 3D flame, no flue needed, and it's currently on sale:",
      products: [{ title: '2000W Electric Fireplace Heater with 3D Flame', handle: 'electric-fireplace', price: '$499', compare_at: '$679', save: 'Save $180' }],
      chips: ['Compare with a bigger model', 'How long is delivery?', 'Is it quiet?'] },
    { match: /desk|standing|office|study/i, reply: "For a small room this compact electric standing desk fits a 1.2m footprint and has memory presets:",
      products: [{ title: 'Compact Electric Standing Desk 1.2m', handle: 'tables-desks', price: '$329', compare_at: '$399', save: 'Save $70' }],
      chips: ['Cheaper option?', 'In stock near me?', 'Weight limit?'] },
    { match: /gazebo|marquee|tent|market/i, reply: "This 3×3m pop-up marquee is waterproof and packs into a wheeled bag — popular for markets:",
      products: [{ title: '3×3m Waterproof Pop-up Marquee Gazebo', handle: 'pe-pvc-commercial-marquee-gazebo', price: '$189' }],
      chips: ['Do you have 3×6m?', 'What are the walls made of?'] },
    { match: /order|track|when.*arrive/i, reply: "That's an order tracking question — our tracking page is the fastest place to check it. Ask me anything about products and I'll jump back in.",
      products: [], chips: ['Ask about a product'], link: { label: 'Track my order', url: '/pages/track-my-order' } },
    { match: /refund|return/i, reply: "That's a returns or refunds question — our returns page has the right next steps. Ask me anything about products and I'll jump back in.",
      products: [], chips: ['Ask about a product'], link: { label: 'Returns & refunds', url: '/pages/returns-refunds' } },
    { match: /trampoline|kids|play/i, reply: "This 10ft trampoline meets AS 4989 safety standards and includes a net enclosure:",
      products: [{ title: '10ft Spring Trampoline with Safety Net', handle: 'trampoline', price: '$279', compare_at: '$349', save: 'Save $70' }],
      chips: ['Bigger sizes?', 'How long to assemble?'] }
  ];

  var FALLBACK = {
    reply: "I couldn't find an exact match, but I can search our full range. Try naming a product type, a room, or a budget — for example “a waterproof gazebo under $200”.",
    products: [], chips: ['Browse all products', 'Talk to a human']
  };

  function mockRespond(message) {
    for (var i = 0; i < MOCK.length; i++) {
      if (MOCK[i].match.test(message)) return MOCK[i];
    }
    return FALLBACK;
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function fitComposerInput(input) {
    var max = 118;
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, max) + 'px';
    input.style.overflowY = input.scrollHeight > max ? 'auto' : 'hidden';
  }
  function signInUrl() {
    var base = CONFIG.storefrontLoginUrl || CONFIG.accountLoginUrl || '/account/login';
    var sep = CONFIG.accountLoginSeparator || (base.indexOf('?') > -1 ? '&' : '?');
    var params = new URLSearchParams(location.search);
    params.set('andi', 'open');
    var returnTo = location.origin + location.pathname + '?' + params.toString() + location.hash;
    if (CONFIG.storefrontLoginUrl) {
      try {
        var url = new URL(base, location.origin);
        url.searchParams.set('return_to', location.pathname + '?' + params.toString() + location.hash);
        return url.pathname + url.search;
      } catch (e) {
        return base;
      }
    }
    return base + sep + 'return_url=' + encodeURIComponent(returnTo) + '&return_to=' + encodeURIComponent(returnTo);
  }
  /* ---- Signing in without leaving the chat ----
     Sending the shopper to /account/login navigates the whole page away, and
     Shopify's new customer accounts ignore return_url/return_to — they land on the
     order profile, so the conversation is lost and they have to find the widget
     again. Instead the login runs in a small popup while the panel stays put.

     There is no way to read the popup's URL (different origin), so completion is
     detected two ways, whichever happens first:
       · the popup closes, or
       · /account stops redirecting, which only happens once a session exists.
     Both end in one reload carrying ?andi=open, so Liquid re-renders with
     signedIn = true and the widget re-opens straight back into the chat. */
  var signInPoll = null;

  /* ---- Sign in with Shop, rendered inside the panel ----
     This is what Shopify Inbox uses, and it is available to themes too: the
     <shop-login-button> custom element ships in shop-js and is served from the
     shop's own CDN path once "Shop" is enabled under Settings → Customer accounts
     → Authentication.

     Finding it took a wrong turn worth recording: there is no
     loader.init-shop-login-button module (that name 404s, which briefly looked
     like the feature was disabled). The real init names come from shop-js's
     client.js — init-customer-accounts is the one that pulls in
     client.shop-login-button_*.en.esm.js.

     Loaded lazily and only for guests, so no cost to signed-in shoppers or to
     anyone who never opens the chat. Any failure leaves the plain anchor in place,
     which still works via the popup path below. */
  var SHOP_LOGIN_MODULE = '/cdn/shopifycloud/shop-js/modules/v2/loader.init-customer-accounts.en.esm.js';
  var shopLoginState = null;

  /* DISABLED 2026-08-11 — the button renders perfectly but its sheet never loads.
     What was verified: the element registers, every shop-js chunk fetches 200,
     the console is silent, Shopify.SignInWithShop.eligible === true, and calling
     the public Shopify.SignInWithShop.initCustomerAccounts() changes nothing — the
     sheet stays a skeleton. Shopify's own surfaces (the account menu, and Inbox,
     which is a first-party iframe) clearly bootstrap it with context that is not
     reachable from a theme this way.

     Left switched off rather than deleted: everything below is correct and ready if
     Shopify documents the missing init, or exposes the account-menu component. Flip
     this to true to try again — but re-test the sheet actually renders content, not
     just that the button appears. */
  var SHOP_LOGIN_ENABLED = false;

  function loadShopLogin() {
    if (!SHOP_LOGIN_ENABLED) return Promise.resolve(false);
    if (shopLoginState) return shopLoginState;
    if (!window.customElements || !window.Promise) {
      shopLoginState = Promise.resolve(false);
      return shopLoginState;
    }
    if (customElements.get('shop-login-button')) {
      shopLoginState = Promise.resolve(true);
      return shopLoginState;
    }
    // Wrapped in new Function so the dynamic import is never parsed by browsers
    // that would choke on the syntax — this file is otherwise plain ES5.
    var dynamicImport;
    try { dynamicImport = new Function('u', 'return import(u);'); }
    catch (e) { shopLoginState = Promise.resolve(false); return shopLoginState; }
    shopLoginState = dynamicImport(SHOP_LOGIN_MODULE)
      .then(function () {
        /* Importing the loader only DEFINES the element and this init function —
           it does not run it. Shopify's own pages call it; we have to as well.
           Without this the button renders and opens its sheet, but the sheet has no
           shop config and sits on a skeleton loader forever with no console error
           and every chunk fetched 200, which is a very confusing way to fail.
           Shopify.SignInWithShop.eligible tells us the shop is allowed to use it. */
        try {
          var siws = window.Shopify && window.Shopify.SignInWithShop;
          if (siws && typeof siws.initCustomerAccounts === 'function') siws.initCustomerAccounts();
        } catch (e) { /* fall through to the capability check below */ }
        return !!customElements.get('shop-login-button');
      })
      .catch(function () { return false; });
    return shopLoginState;
  }

  function reopenAfterSignIn() {
    if (signInPoll) { clearInterval(signInPoll); signInPoll = null; }
    try { sessionStorage.setItem('andi_resume', '1'); } catch (e) {}
    var params = new URLSearchParams(location.search);
    params.set('andi', 'open');
    location.href = location.pathname + '?' + params.toString() + location.hash;
  }

  function isSignedInNow() {
    /* Ask the storefront itself, not /account.
       Two earlier attempts at /account both failed, for opposite reasons:
         · "not a redirect means signed in" — a 404 satisfies that, so it declared
           success on a page where /account does not exist;
         · "status must be 200" — under NEW customer accounts /account 302s to
           account.<shop> whether or not there is a session, so redirect:"manual"
           returns opaqueredirect in both cases and this could never be true.

       The snippet already renders `signedIn: true|false` into window.AD_ANDI on
       every page, so fetching any same-origin page and reading that flag back is
       the one signal that is correct for both classic and new customer accounts.

       The URL carries a fresh timestamp and cache:"no-store" every time, AND it
       points at /cart rather than the homepage. Both matter:
         · a fixed URL let the first probe's "signedIn: false" HTML be cached and
           re-read forever;
         · the homepage is full-page-cached at Shopify's edge, which kept serving a
           guest copy even with a unique query string — measured directly, the panel
           showed "Signed in" after a hard refresh while the probe still read false.
       /cart is session-dependent so Shopify never full-page-caches it, and it still
       renders the snippet that emits window.AD_ANDI.signedIn. */
    return fetch('/cart?andi_probe=' + Date.now(), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'text/html' },
    })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (html) { return /signedIn\s*:\s*true/.test(html); })
      .catch(function () { return false; });
  }

  /* Poll-only watcher for the in-panel Shop button, which never opens a window we
     hold a handle to. Same probe and same 5-minute budget as the popup path. */
  function watchForSignIn() {
    var waited = 0;
    if (signInPoll) clearInterval(signInPoll);
    signInPoll = setInterval(function () {
      waited += 2500;
      isSignedInNow().then(function (yes) { if (yes) reopenAfterSignIn(); });
      if (waited > 5 * 60 * 1000) { clearInterval(signInPoll); signInPoll = null; }
    }, 2500);
  }

  function openSignInPopup() {
    var w = 480, h = 700;
    var left = Math.max(0, (screen.width - w) / 2), top = Math.max(0, (screen.height - h) / 2);
    var popup = window.open(signInUrl(), 'andi-signin',
      'width=' + w + ',height=' + h + ',left=' + left + ',top=' + top + ',resizable=yes,scrollbars=yes');
    // Blocked by the browser: fall back to a normal navigation rather than
    // leaving the shopper with a button that does nothing.
    if (!popup || popup.closed || typeof popup.closed === 'undefined') return false;
    try { popup.focus(); } catch (e) {}

    /* popup.closed is checked often because it is free; the signed-in probe costs a
       full page fetch, so it runs every 5s and gives up after 3 minutes. In practice
       the popup-closed path fires first — the probe only matters when the shopper
       leaves the login window open after finishing. */
    var waited = 0;
    if (signInPoll) clearInterval(signInPoll);
    signInPoll = setInterval(function () {
      waited += 1000;
      if (popup.closed) { reopenAfterSignIn(); return; }
      // 2.5s, not 5s: this is what closes the account window the shopper is left
      // staring at, so the delay is user-visible. The probe is one cached-bypassing
      // page fetch — cheap enough at this rate for the few minutes it runs.
      if (waited % 2500 === 0) {
        isSignedInNow().then(function (yes) {
          if (!yes) return;
          try { popup.close(); } catch (e) {}
          reopenAfterSignIn();
        });
      }
      // 5 minutes: Shopify's login can involve email codes or a Shop app handoff,
      // and the popup is often left open on the account page afterwards — the probe,
      // not popup.closed, is what ends the wait in that case.
      if (waited > 5 * 60 * 1000) { clearInterval(signInPoll); signInPoll = null; }
    }, 1000);
    return true;
  }

  function shouldResume() {
    // shop_sign_in=true is Shopify's own marker on the post-login return trip, so the
    // chat reopens even if sessionStorage was cleared along the way.
    var fromShopify = /[?&](andi=open|shop_sign_in=true)\b/.test(location.search);
    try { return fromShopify || sessionStorage.getItem('andi_resume') === '1'; }
    catch (e) { return fromShopify; }
  }
  function clearResumeFlag() {
    try { sessionStorage.removeItem('andi_resume'); } catch (e) {}
    if (!/[?&](andi=open|shop_sign_in=true)\b/.test(location.search) || !history.replaceState) return;
    var params = new URLSearchParams(location.search);
    params.delete('andi');
    params.delete('shop_sign_in');
    history.replaceState({}, '', location.pathname + (params.toString() ? '?' + params.toString() : '') + location.hash);
  }

  function AskAndi(root) {
    this.root = root;
    this.log = root.querySelector('[data-andi-log]');
    this.form = root.querySelector('[data-andi-form]');
    this.input = root.querySelector('[data-andi-input]');
    this.send = root.querySelector('[data-andi-send]');
    this.history = [];
    this.greeted = false;
    this.openLogged = false;
    this.lastMessageId = 0;
    this.pollTimer = null;
    this.polling = false;
    this.pollFailures = 0;
    this.welcomeRecs = null;
    this.welcomePicksHead = null;
    this.popularProbed = false;
    this.identityProbed = false;
    this.signedIn = !!CONFIG.signedIn;
    this.bind();
  }

  AskAndi.prototype.logEvent = function (eventType, eventText) {
    if (!USE_BACKEND) return;
    fetch(ENDPOINT, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ eventType: eventType, eventText: eventText || '', sessionId: sessionId(), channel: channelOf(), pageContext: pageContext() })
    }).catch(function () {});
  };

  AskAndi.prototype.probeIdentity = function () {
    var self = this;
    if (!USE_BACKEND || this.identityProbed) return;
    this.identityProbed = true;
    fetch(ENDPOINT, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ eventType: 'identity_probe', sessionId: sessionId(), channel: channelOf(), pageContext: pageContext() })
    }).then(function (r) { return r.json(); }).then(rememberToken).then(function (data) {
      if (data && data.identity && data.identity.signedIn) self.setIdentity(data.identity.label || 'Signed in');
    }).catch(function () {});
  };

  /* The opening deck is curated server-side but priced live, so a price change in
     Shopify cannot leave a stale number on the first thing a shopper sees. The
     hardcoded POPULAR_PRODUCTS above stay as the offline fallback: this only ever
     replaces them once real data is in hand, and never blocks the panel opening.
     Read-only on the server — it does not create a support ticket. */
  AskAndi.prototype.refreshPopularProducts = function () {
    var self = this;
    if (!USE_BACKEND || this.popularProbed) return;
    this.popularProbed = true;
    fetch(ENDPOINT, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ eventType: 'popular_products', sessionId: sessionId(), channel: channelOf() })
    }).then(function (r) { return r.json(); }).then(rememberToken).then(function (data) {
      var products = (data && data.products) || [];
      if (!products.length) return;
      /* Keep the short hand-written titles — the catalogue's real ones are long
         enough to clamp mid-word in a 134px card ("72 inch Professional In-ground
         Basketball System with Hoop Tempered Glass Backboard"). Everything that
         can go stale (price, sale price, image) comes from the server. */
      self.updateWelcomeProducts(products.map(function (p) {
        var local = null;
        for (var i = 0; i < POPULAR_PRODUCTS.length; i++) {
          if (POPULAR_PRODUCTS[i].handle === p.handle) { local = POPULAR_PRODUCTS[i]; break; }
        }
        return {
          title: (local && local.title) || p.title,
          handle: p.handle,
          price: p.price || (local && local.price) || '',
          compare_at: p.compare_at || '',
          save: p.save || '',
          image: p.image || (local && local.image) || ''
        };
      }));
    }).catch(function () {});
  };

  AskAndi.prototype.bind = function () {
    var self = this;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-andi-open]')) { e.preventDefault(); self.open(); }
      if (e.target.closest('[data-andi-expand]')) { e.preventDefault(); self.toggleExpand(); }
      if (e.target.closest('[data-andi-close]')) self.close();
      if (e.target.closest('[data-andi-signin]')) {
        // Let the navigation happen. storefront_login_url returns to the current
        // page; adding ?andi=open first gives Shopify a URL that reopens the panel
        // even if sessionStorage is lost during the hosted account flow.
        try { sessionStorage.setItem('andi_resume', '1'); } catch (err) {}
        if (CONFIG.storefrontLoginUrl && history.replaceState && !/[?&]andi=open\b/.test(location.search)) {
          var params = new URLSearchParams(location.search);
          params.set('andi', 'open');
          history.replaceState({}, '', location.pathname + '?' + params.toString() + location.hash);
        }
      }
    });
    this.root.querySelector('.andi__overlay').addEventListener('click', function () { self.close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });

    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
    this.input.addEventListener('input', function () {
      fitComposerInput(self.input);
      self.send.disabled = !self.input.value.trim();
    });
    this.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); self.submit(); }
    });
    this.log.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-andi-chip]');
      if (chip) self.submit(chip.textContent);
    });
  };

  AskAndi.prototype.open = function () {
    this.root.classList.add('is-open');
    this.root.setAttribute('aria-hidden', 'false');
    if (window.matchMedia('(max-width:767px)').matches) document.body.style.overflow = 'hidden';
    if (!this.openLogged) { this.openLogged = true; this.logEvent('widget_opened'); }
    if (!this.greeted) {
      this.greeted = true;
      this.addWelcome();
      if (GREETING.chips && GREETING.chips.length) this.addChips(GREETING.chips);
      this.logEvent('initial_greeting_shown', GREETING.reply);
    }
    this.probeIdentity();
    this.startPolling();
    var self = this; setTimeout(function () { self.input.focus(); }, 250);
  };

  AskAndi.prototype.close = function () {
    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    this.stopPolling();
  };

  AskAndi.prototype.toggleExpand = function () {
    var expanded = this.root.classList.toggle('is-expanded');
    var button = this.root.querySelector('[data-andi-expand]');
    if (button) button.setAttribute('aria-label', expanded ? 'Shrink assistant' : 'Expand assistant');
  };

  AskAndi.prototype.startPolling = function () {
    if (!USE_BACKEND || this.pollTimer || this.polling) return;
    this.schedulePoll(8000);
  };

  AskAndi.prototype.stopPolling = function () {
    if (this.pollTimer) clearTimeout(this.pollTimer);
    this.pollTimer = null;
  };

  AskAndi.prototype.schedulePoll = function (delay) {
    var self = this;
    this.stopPolling();
    this.pollTimer = setTimeout(function () { self.pollMessages(); }, delay);
  };

  AskAndi.prototype.pollMessages = function () {
    var self = this;
    if (!this.root.classList.contains('is-open') || this.polling) return;
    this.polling = true;
    fetch(ENDPOINT + '?after=' + encodeURIComponent(String(this.lastMessageId || 0)), { headers: readHeaders() })
      .then(function (r) { return r.json(); })
      .then(rememberToken)
      .then(function (data) {
        var messages = data && data.messages ? data.messages : [];
        for (var i = 0; i < messages.length; i++) {
          var msg = messages[i];
          var id = Number(msg.id || 0);
          if (id && id <= self.lastMessageId) continue;
          if (msg.author === 'customer') { /* local sender already rendered this turn */ }
          else if (msg.author === 'agent') self.addBubble('staff', msg.text || '', 'AlwaysDirect team');
          else if (msg.author === 'andi') self.addBubble('a', msg.text || '');
          if (id > self.lastMessageId) self.lastMessageId = id;
        }
        self.pollFailures = 0;
      })
      .catch(function () { self.pollFailures += 1; })
      .then(function () {
        self.polling = false;
        if (self.root.classList.contains('is-open')) self.schedulePoll(self.pollFailures >= 3 ? 30000 : 8000);
      });
  };

  AskAndi.prototype.submit = function (forced) {
    var text = (forced || this.input.value).trim();
    if (!text) return;
    if (!forced && this.captureOrderVerifyInput(text)) return;
    if (forced) this.logEvent('chip_clicked', text);
    this.addBubble('u', text);
    this.history.push({ role: 'user', text: text });
    this.updateWelcomeProducts(relatedProducts(text), 'You might like');
    this.input.value = ''; fitComposerInput(this.input); this.send.disabled = true;
    this.respond(text);
  };

  AskAndi.prototype.captureOrderVerifyInput = function (text) {
    var form = this.log.querySelector('[data-andi-order-form]');
    if (!form) return false;
    var emailInput = form.elements.email;
    var orderInput = form.elements.orderNumber;
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text) && emailInput) {
      emailInput.value = text;
      this.input.value = ''; fitComposerInput(this.input); this.send.disabled = true;
      this.addBubble('a', 'I added that email to the verification form. Please enter your order number as well.');
      if (orderInput) orderInput.focus();
      return true;
    }
    if (/^#?[a-z0-9-]{3,40}$/i.test(text) && /\d/.test(text) && orderInput) {
      orderInput.value = text.charAt(0) === '#' ? text : '#' + text;
      this.input.value = ''; fitComposerInput(this.input); this.send.disabled = true;
      if (emailInput && emailInput.value.trim()) this.submitOrderVerify(form);
      else {
        this.addBubble('a', 'I added that order number to the verification form. Please enter the email used at checkout as well.');
        if (emailInput) emailInput.focus();
      }
      return true;
    }
    return false;
  };

  AskAndi.prototype.respond = function (text) {
    var self = this;
    var typing = this.addTyping();
    var handle = function (data) {
      typing.remove();
      var responseId = Number(data.lastMessageId || 0);
      if (!responseId || responseId > self.lastMessageId) {
        self.history.push({ role: 'assistant', text: data.reply });
        self.render(data);
        if (data.reply) self.logEvent('ai_reply_rendered', data.reply);
      }
      if (responseId > self.lastMessageId) self.lastMessageId = responseId;
    };
    if (USE_BACKEND) {
      var trail = readBehavior();
      fetch(ENDPOINT, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text, history: this.history.slice(-10), sessionId: sessionId(), channel: channelOf(), pageContext: pageContext(), behavior: trail })
      }).then(function (r) { return r.json(); }).then(rememberToken)
        .then(function (data) {
          if (trail.length) writeBehavior([]);
          handle(data);
        })
        .catch(function () { handle(FALLBACK); });
    } else {
      setTimeout(function () { handle(mockRespond(text)); }, 650 + Math.random() * 500);
    }
  };

  AskAndi.prototype.render = function (data) {
    if (data.reply) this.addBubble('a', data.reply);
    if (data.identity) this.setIdentity(data.identity.label || 'Verified');
    if (data.orderSummary) this.addOrderSummary(data.orderSummary);
    if (data.products && data.products.length) this.updateWelcomeProducts(data.products, 'You might like');
    this.addProducts(data.products);
    if (data.link && data.link.url) this.addLink(data.link);
    if (data.verifyOrderRequired) this.addOrderVerifyForm();
    if (data.handoff) this.addHandoffForm(data.handoff);
    if (data.chips && data.chips.length) this.addChips(data.chips);
    this.log.scrollTop = this.log.scrollHeight;
  };

  /* Swap the Sign in button for a local status line. The panel stays exactly where
     it is — this is the whole point of the popup — so the shopper can see the chat
     behind the login and knows what is happening. Restores itself if they give up. */
  AskAndi.prototype.showSignInPending = function () {
    var wrap = this.log.querySelector('.andi-welcome__copy');
    var btn = wrap && wrap.querySelector('[data-andi-signin]');
    if (!btn) return;
    var note = document.createElement('span');
    note.className = 'andi-welcome__pending';
    note.setAttribute('data-andi-signin-pending', '');
    note.innerHTML = 'Signing in… <button type="button" data-andi-signin-cancel>Cancel</button>';
    btn.replaceWith(note);
    var self = this;
    note.querySelector('[data-andi-signin-cancel]').addEventListener('click', function () {
      if (signInPoll) { clearInterval(signInPoll); signInPoll = null; }
      try { sessionStorage.removeItem('andi_resume'); } catch (e) {}
      var again = document.createElement('a');
      again.className = 'andi-welcome__signin';
      again.href = signInUrl();
      again.setAttribute('data-andi-signin', '');
      again.textContent = 'Sign in';
      note.replaceWith(again);
      self.log.scrollTop = self.log.scrollHeight;
    });
  };

  /* Swap the fallback anchor for the real Shop button once shop-js is ready.
     The button lives in a shadow root, so its click cannot be intercepted — but
     clicks are composed and still reach this host, which is all we need to start
     watching for the session to appear. Completion is detected by the same
     same-origin probe the popup path uses, so it does not depend on knowing which
     internal event Shopify fires. */
  AskAndi.prototype.upgradeSignInToShop = function () {
    var self = this;
    var slot = this.log.querySelector('[data-andi-signin-slot]');
    if (!slot) return;
    loadShopLogin().then(function (ready) {
      var current = self.log.querySelector('[data-andi-signin-slot]');
      if (!current) return;

      if (!ready) {
        /* shop-js unavailable. Only NOW offer the old link, which sends the shopper
           to /account/login. That route is a last resort: under new customer
           accounts it finishes on account.<shop> and establishes the session on
           that subdomain only, so the storefront still sees a guest and the shopper
           is asked to sign in again. */
        var a = document.createElement('a');
        a.className = 'andi-welcome__signin';
        a.href = signInUrl();
        a.setAttribute('data-andi-signin', '');
        a.textContent = 'Sign in';
        current.replaceWith(a);
        return;
      }

      var host = document.createElement('span');
      host.className = 'andi-welcome__shoplogin';
      host.setAttribute('data-andi-shop-login', '1');
      host.appendChild(document.createElement('shop-login-button'));
      host.addEventListener('click', function () {
        try { sessionStorage.setItem('andi_resume', '1'); } catch (e) {}
        watchForSignIn();
      });
      current.replaceWith(host);
    });
  };

  AskAndi.prototype.addWelcome = function () {
    var card = document.createElement('div');
    card.className = 'andi-welcome';
    var signIn = CONFIG.signedIn
      ? '<span class="andi-welcome__signed" data-andi-identity>Signed in</span>'
      /* A plain top-level link — deliberately NOT a popup.
         Shopify finishes the login by navigating the browser back to the storefront
         with ?shop_sign_in=true, and THAT navigation is what establishes the
         storefront session. A popup swallows it: the popup completes the round trip,
         the opener never does, so window.AD_ANDI.signedIn stays false forever no
         matter how the page is probed. Four rounds of testing chased the probe
         before the address bar gave it away. Keep this a normal anchor. */
      : '<a class="andi-welcome__signin" href="' + esc(signInUrl()) + '" data-andi-signin>Sign in</a>';
    card.innerHTML = '<div class="andi-welcome__copy">' + signIn +
      '<h2>Hi there!</h2>' +
      '<p>Ask about products, sizing, delivery, returns or your order.</p>' +
      '</div>' +
      '<div class="andi-welcome__picks">' +
      '<span class="andi-welcome__pickshead" data-andi-picks-head>Popular right now</span>' +
      '<div class="andi-welcome__recs" aria-label="Popular picks"></div></div>' +
      '<small>Visible to AlwaysDirect for service quality. See <a href="/policies/privacy-policy">privacy policy</a>.</small>';
    this.log.appendChild(card);
    this.welcomeRecs = card.querySelector('.andi-welcome__recs');
    this.welcomePicksHead = card.querySelector('[data-andi-picks-head]');
    this.updateWelcomeProducts(POPULAR_PRODUCTS.slice(0, 2));
    this.refreshPopularProducts();
    if (!CONFIG.signedIn) this.upgradeSignInToShop();
  };

  AskAndi.prototype.setIdentity = function (label) {
    var wrap = this.log.querySelector('.andi-welcome__copy');
    if (!wrap) return;
    var badge = wrap.querySelector('[data-andi-identity]');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'andi-welcome__signed';
      badge.setAttribute('data-andi-identity', '');
      var signIn = wrap.querySelector('[data-andi-signin], [data-andi-signin-slot], [data-andi-shop-login]');
      if (signIn) signIn.replaceWith(badge);
      else wrap.insertBefore(badge, wrap.firstChild);
    }
    badge.textContent = label || 'Verified';
    this.signedIn = true;
  };

  /* label is only passed once the picks stop being the generic popular list — the
     heading has to stop saying "Popular right now" when the cards are answering
     what the shopper just asked about. */
  AskAndi.prototype.updateWelcomeProducts = function (products, label) {
    if (!this.welcomeRecs || !products || !products.length) return;
    var picks = products.slice(0, 2);
    this.welcomeRecs.innerHTML = picks.map(function (p, i) {
      var href = p.handle ? '/products/' + p.handle : (p.url || '#');
      var media = (p.image ? '<img src="' + esc(sizedImage(p.image, 140)) + '" alt="' + esc(p.title || 'Recommended product') + '" loading="lazy">' : '') + PLACEHOLDER_SVG;
      var price = p.price ? '<small>' + esc(p.price) + '</small>' : '';
      return '<a class="andi-mini-card andi-mini-card--' + (i ? 'back' : 'front') + '" href="' + esc(href) + '"><span class="andi-mini-card__media">' + media + '</span>' +
        '<span class="andi-mini-card__text"><span class="andi-mini-card__title">' + esc(p.title || 'Popular product') + '</span>' + price + '</span></a>';
    }).join('');
    if (label && this.welcomePicksHead) this.welcomePicksHead.textContent = label;
    dropDeadImages(this.welcomeRecs);
  };

  AskAndi.prototype.addHandoffForm = function (handoff) {
    var self = this;
    var form = document.createElement('form');
    form.className = 'andi-handoff';
    var qs = (handoff.questions || []).slice(0, 2);
    var contactRequired = handoff.contactRequired !== false && !this.signedIn;
    var contactFields = contactRequired
      ? '<label><span>Name</span><input name="name" type="text" required autocomplete="name" maxlength="120"></label>' +
        '<label><span>Email</span><input name="email" type="email" required autocomplete="email" maxlength="180"></label>' +
        '<label><span>Phone (optional)</span><input name="phone" type="tel" autocomplete="tel" maxlength="40"></label>'
      : '';
    var fields = qs.map(function (q) {
      return '<label><span>' + esc(q.label || 'Extra detail') + '</span><input name="' + esc(q.key || 'detail') + '" type="text" ' + (q.required ? 'required' : '') + ' maxlength="180"></label>';
    }).join('');
    form.innerHTML = '<strong>Let our team confirm</strong>' +
      contactFields +
      fields +
      '<p>' + (contactRequired ? 'We will only use these details to follow up about this question.' : 'We will send this to our customer service team using your account details.') + ' No third-party tracking.</p>' +
      '<button type="submit">Send to team</button>';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.submitHandoff(form);
    });
    this.log.appendChild(form);
  };

  AskAndi.prototype.addOrderVerifyForm = function () {
    if (this.log.querySelector('[data-andi-order-form]')) return;
    var self = this;
    var form = document.createElement('form');
    form.className = 'andi-order';
    form.setAttribute('data-andi-order-form', '');
    form.innerHTML = '<strong>Verify your order</strong>' +
      '<label><span>Email used at checkout</span><input name="email" type="email" required autocomplete="email" maxlength="180"></label>' +
      '<label><span>Order number</span><input name="orderNumber" type="text" required autocomplete="off" placeholder="Example: #AD2019605" maxlength="48"></label>' +
      '<p>This only verifies this chat session. Andi will not show address, phone, or payment details.</p>' +
      '<button type="submit">Verify order</button>';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.submitOrderVerify(form);
    });
    this.log.appendChild(form);
    this.log.scrollTop = this.log.scrollHeight;
  };

  AskAndi.prototype.submitOrderVerify = function (form) {
    var self = this;
    var email = (form.elements.email && form.elements.email.value || '').trim();
    var orderNumber = (form.elements.orderNumber && form.elements.orderNumber.value || '').trim();
    var btn = form.querySelector('button');
    if (btn) { btn.disabled = true; btn.textContent = 'Verifying...'; }
    fetch(ENDPOINT, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ eventType: 'order_verify', email: email, orderNumber: orderNumber, sessionId: sessionId(), channel: channelOf(), pageContext: pageContext() })
    }).then(function (r) { return r.json(); }).then(rememberToken).then(function (data) {
      if (!data || data.ok === false) throw new Error(data && data.message || 'Unable to verify');
      form.remove();
      self.render(data);
    }).catch(function (err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Verify order'; }
      self.addBubble('a', (err && err.message) || 'I could not match that email and order number. Please check both and try again.');
    });
  };

  AskAndi.prototype.addOrderSummary = function (order) {
    if (!order || !order.name) return;
    var card = document.createElement('div');
    card.className = 'andi-order-card';
    var status = order.shipmentStatus || order.fulfillmentStatus || 'Checking';
    var items = (order.items || []).slice(0, 3).map(function (item) {
      return '<li>' + esc((item.quantity || 1) + 'x ' + (item.title || 'Order item')) + '</li>';
    }).join('');
    var tracking = (order.tracking || []).filter(function (t) { return t.url; })[0];
    card.innerHTML = '<strong>Order ' + esc(order.name) + '</strong>' +
      '<span>Status: ' + esc(status) + '</span>' +
      (items ? '<ul>' + items + '</ul>' : '') +
      (tracking ? '<a href="' + esc(tracking.url) + '" target="_blank" rel="noopener">View tracking</a>' : '');
    this.log.appendChild(card);
  };

  AskAndi.prototype.submitHandoff = function (form) {
    var self = this;
    var email = (form.elements.email && form.elements.email.value || '').trim();
    var name = (form.elements.name && form.elements.name.value || '').trim();
    var phone = (form.elements.phone && form.elements.phone.value || '').trim();
    var answers = {};
    var inputs = form.querySelectorAll('input[name]:not([name="email"]):not([name="name"]):not([name="phone"])');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value.trim()) answers[inputs[i].name] = inputs[i].value.trim();
    }
    var btn = form.querySelector('button');
    if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
    fetch(ENDPOINT, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ eventType: 'handoff_submitted', email: email, name: name, phone: phone, answers: answers, sessionId: sessionId(), channel: channelOf(), pageContext: pageContext() })
    }).then(function (r) { return r.json(); }).then(rememberToken).then(function (data) {
      if (!data || data.ok === false) throw new Error(data && data.message || 'Unable to submit');
      form.remove();
      self.render({ reply: data.reply || ('Thanks - your reference is ' + (data.ref || 'created') + '.'), chips: data.chips || [] });
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Send to team'; }
      self.addBubble('a', 'Sorry, I could not submit that. Please check the form and try again.');
    });
  };

  AskAndi.prototype.addLink = function (link) {
    var a = document.createElement('a');
    a.className = 'andi-linkbtn';
    a.href = link.url;
    a.textContent = link.label || 'Open';
    this.log.appendChild(a);
  };

  AskAndi.prototype.addBubble = function (who, text, label) {
    var el = document.createElement('div');
    el.className = 'andi-msg andi-msg--' + who;
    if (label) el.innerHTML = '<span class="andi-msg__label">' + esc(label) + '</span>' + esc(text);
    else el.textContent = text;
    this.log.appendChild(el);
    this.log.scrollTop = this.log.scrollHeight;
  };

  AskAndi.prototype.addTyping = function () {
    var el = document.createElement('div');
    el.className = 'andi-typing';
    el.innerHTML = '<i></i><i></i><i></i>';
    this.log.appendChild(el);
    this.log.scrollTop = this.log.scrollHeight;
    return el;
  };

  AskAndi.prototype.addProduct = function (p) {
    var a = document.createElement('a');
    a.className = 'andi-card';
    a.href = p.handle ? '/products/' + p.handle : (p.url || '#');
    var media = (p.image ? '<img src="' + esc(sizedImage(p.image, 60)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + PLACEHOLDER_SVG;
    var price = p.price ? '<div class="andi-card__price">' + esc(p.price) +
      (p.compare_at ? '<s>' + esc(p.compare_at) + '</s>' : '') +
      (p.save ? '<em>' + esc(p.save) + '</em>' : '') + '</div>' : '';
    a.innerHTML = '<span class="andi-card__media">' + media + '</span>' +
      '<span class="andi-card__body"><span class="andi-card__title">' + esc(p.title) + '</span>' + price + '</span>';
    dropDeadImages(a);
    this.log.appendChild(a);
  };

  /* Recommendations inside the conversation. A single suggestion stays a
     full-width row — a one-item carousel is just a card that scrolls badly — but
     two or more go side by side in a scroll-snapped rail, so comparing them does
     not mean scrolling the whole transcript past them. */
  AskAndi.prototype.addProducts = function (products) {
    var list = (products || []).filter(Boolean);
    if (!list.length) return;
    if (list.length === 1) { this.addProduct(list[0]); return; }
    var rail = document.createElement('div');
    rail.className = 'andi-rail';
    rail.innerHTML = '<div class="andi-rail__track" role="list">' + list.map(function (p) {
      var href = p.handle ? '/products/' + p.handle : (p.url || '#');
      var media = (p.image ? '<img src="' + esc(sizedImage(p.image, 150)) + '" alt="' + esc(p.title || 'Product') + '" loading="lazy">' : '') + PLACEHOLDER_SVG;
      var price = p.price ? '<span class="andi-rail-card__price">' + esc(p.price) +
        (p.compare_at ? '<s>' + esc(p.compare_at) + '</s>' : '') +
        (p.save ? '<em>' + esc(p.save) + '</em>' : '') + '</span>' : '';
      return '<a class="andi-rail-card" role="listitem" href="' + esc(href) + '">' +
        '<span class="andi-rail-card__media">' + media + '</span>' +
        '<span class="andi-rail-card__title">' + esc(p.title || 'Product') + '</span>' + price + '</a>';
    }).join('') + '</div>';
    dropDeadImages(rail);
    this.log.appendChild(rail);
  };

  AskAndi.prototype.addChips = function (chips) {
    var wrap = document.createElement('div');
    wrap.className = 'andi-chips';
    wrap.innerHTML = chips.map(function (c) {
      return '<button type="button" class="andi-chip" data-andi-chip>' + esc(c) + '</button>';
    }).join('');
    this.log.appendChild(wrap);
  };

  function init() {
    trackBehavior();
    var root = document.querySelector('[data-andi-root]');
    if (root && !root.__andi) {
      root.__andi = new AskAndi(root);
      if (shouldResume()) {
        clearResumeFlag();
        root.__andi.open();
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
